module.exports = __webpack_public_path__ + "static/media/jiegou.60ba8f60.png";